// prefer default export if available
const preferDefault = m => (m && m.default) || m

exports.components = {
  "component---node-modules-geocine-gatsby-theme-organization-src-templates-index-js": () => import("./../../../node_modules/@geocine/gatsby-theme-organization/src/templates/index.js" /* webpackChunkName: "component---node-modules-geocine-gatsby-theme-organization-src-templates-index-js" */)
}

